import { VueController } from 'util/vue_controller'

// Connects to data-controller="sales-activity-partipations"
export default class extends VueController {
  static vueComponent = 'sales-activity-participations'

  static targets = ['tableBody']

  static values = {
    activities: Array,
    distributors: Array,
    hideSupplier: Boolean
  }

  get props () {
    return {
      activities: this.activitiesValue,
      distributors: this.distributorsValue,
      hideSupplier: this.hideSupplierValue
    }
  }

  get vueTarget () {
    return this.tableBodyTarget
  }
}
